import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Plug } from "lucide-react";
import { ScrollReveal } from "@/components/ScrollReveal";
import IntegrationOrbit from "@/components/IntegrationOrbit";
import { useLocale } from "@/i18n/LocaleProvider";


const IntegrationsSection = () => {
  const { t } = useTranslation();
  const { localize } = useLocale();

  return (
    <section
      id="integrations"
      className="relative overflow-hidden border-t border-border section-y-tight"
    >
      <div className="absolute inset-0 tech-dots pointer-events-none opacity-[0.08]" />
      <div className="container relative z-10">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-10">
          {/* Left: copy */}
          <ScrollReveal className="order-2 text-center lg:order-1 lg:text-left">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-border bg-card/60 px-4 py-1.5 backdrop-blur-sm">
              <Plug size={14} className="text-accent" />
              <span className="mono-label text-muted-foreground">{t("integrations.teaser.kicker")}</span>
            </div>
            <h2 className="text-[1.55rem] sm:text-3xl font-bold leading-tight tracking-tight text-foreground md:text-4xl lg:text-5xl">
              {t("integrations.teaser.title")}{" "}
              <span className="gradient-text">{t("integrations.teaser.titleAccent")}</span>
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-[15px] sm:text-lg leading-relaxed text-muted-foreground lg:mx-0">
              {t("integrations.teaser.body")}
            </p>
            <div className="mt-9 flex justify-center lg:justify-start">
              <span className="hover-glow-accent inline-block">
                <Link
                  to={localize("/integrations")}
                  className="group inline-flex items-center gap-2 btn-clip bg-primary px-8 py-4 text-lg font-semibold text-primary-foreground btn-label-contrast transition-transform duration-200 active:scale-[0.97]"
                >
                  {t("integrations.teaser.cta")}
                  <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </span>
            </div>
          </ScrollReveal>

          {/* Right: orbit */}
          <ScrollReveal delay={120} className="order-1 lg:order-2">
            <IntegrationOrbit coreLabel={t("integrations.teaser.core")} />
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;
